export default "__VITE_ASSET__wRbfY73i__"